<template>
  <section>
    <!-- SB-36 -->
    <banner-full-width headerText="Sécurité individuelle"></banner-full-width>
    <div
      id="sb-36"
      v-if="$store.state.currentLocation >= 36"
    >
      <content-block>
        <!-- 5-01-00 -->
        <!-- <banner-full-width headerText=""></banner-full-width> -->
        <!-- <h1 class="animated infinite bounce delay-2s">Example</h1> -->
        <h2 class="content-block__header content-block__header--red">À venir</h2>
        <p>Que vous soyez débutant ou expérimenté en aviron, la sécurité devrait toujours être au cœur de vos préoccupations avant de sortir sur l'eau. Dans cette section, nous aborderons la sécurité individuelle. </p>
        <button-sequenced
          class="btn-nav--red"
          :loc="37"
          link="sb-37"
        >
          Allons-y
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-37 -->
    <div
      id="sb-37"
      class="bg-img bg-img--03"
      v-if="$store.state.currentLocation >= 37"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Assumer la responsabilité de sa propre sécurité</h2>
        <p>La sécurité des rameurs repose sur la connaissance des facteurs environnementaux, mais aussi une excellente conscience de soi.</p>
        <p>En tant que rameur responsable, tenez compte de ces facteurs avant de sortir sur l'eau.</p>
        <ul class="chevron-list">
          <li>Votre capacité à nager</li>
          <li>Votre confort avec le VFI</li>
          <li>Vos connaissances de la circulation sur le plan d'eau</li>
          <li>Votre entraînement prévu</li>
          <li>La pertinence de vos vêtements selon le temps qu'il fait</li>
          <li>L'équipement de sécurité nécessaire  </li>
        </ul>
        <button-sequenced
          class="btn-nav--red"
          :loc="38"
          link="sb-38"
        >
          De quoi réfléchir
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-38 -->
    <div
      id="sb-38"
      v-if="$store.state.currentLocation >= 38"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">S’interroger  </h2>
        <div class="row">
          <div class="col-md-4 text-red">
            <p class="pt-4">Lorsque vous vous préparez à vous rendre sur l'eau, voici quelques questions à vous poser{{'\xa0'}}:</p>
          </div>
          <div class="col-md-4 col-sm-6">
            <ul class="grid-list">
              <li>Fait-il très froid ou très chaud?</li>
              <li>Suis-je habillé de manière convenable?</li>
              <li>Ai-je tout l'équipement nécessaire? </li>
              <li>Qui d’autre sera au club?  </li>
            </ul>
          </div>
          <div class="col-md-4 col-sm-6">
            <ul class="grid-list grid-list--border-left">
              <li>Quelle pièce d'équipement de sécurité d'embarcation dois-je apporter? </li>
              <li>Ai-je signé le journal de sortie et d'entrée?</li>
              <li>D'autres personnes sont-elles au courant que je suis sorti ramer?</li>
            </ul>
          </div>
        </div>
        <button-sequenced
          class="btn-nav--red"
          :loc="39"
          link="sb-39"
        >
          Excellentes questions
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-39 -->
    <div
      id="sb-39"
      class="bg-img bg-img--05"
      v-if="$store.state.currentLocation >= 39"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Évaluer sa capacité de nager </h2>
        <p>L'aviron étant un sport nautique, il est possible que vous vous retrouviez un jour dans l'eau.  </p>
        <p>Cela étant dit, il est <strong>fortement recommandé de savoir nager sur une distance minimale de 50 mètres et de pouvoir garder la tête hors de l'eau pendant trois minutes</strong> avec des vêtements légers. Si vous chavirez, cela laissera du temps à un entraîneur ou à une embarcation de sécurité de venir vous aider ou vous permettra de retourner dans votre bateau. Il est possible que ce soit une condition indiquée dans le Code de sécurité de votre club pour avoir le droit de ramer.</p>
        <p>Si vous ne pouvez pas nager sur une distance de 50 mètres ou garder votre tête hors de l'eau, sans aide, pendant trois minutes, de nombreux cours de natation publics ou privés peuvent vous aider à acquérir ces aptitudes.</p>
        <p>S'il s'agit d'une exigence de votre club, il vous faudra peut-être obtenir un certificat de réussite de la part d'un sauveteur et passer un test auprès de la personne responsable de la sécurité de votre club avant de pouvoir monter dans une embarcation d'aviron.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="40"
          link="sb-40"
        >
          C'est raisonnable
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-40 -->
    <div
      id="sb-40"
      v-if="$store.state.currentLocation >= 40"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Vérifier votre VFI</h2>
        <p>Vérifiez toujours l'intégrité de votre VFI avant de le placer dans l'embarcation. Assurez-vous de savoir comment utiliser correctement le type de VFI qui se trouve dans votre embarcation d'aviron ou dans l'embarcation de l'entraîneur.</p>
        <p>Que ce soit un VFI fourni par le club ou le vôtre, exercez-vous à l'enfiler à quelques reprises pendant l'année et si possible, essayez de l'enfiler dans l'eau. Cela vous permettra de comprendre la façon dont les courroies s'attachent et tous les détails que vous devez savoir. Si votre VFI gonflable est doté d'une cartouche de CO<sub>2</sub>, elle doit être remplacée.</p>
        <p>N'oubliez pas que selon la réglementation de Transports Canada, les personnes de moins de 16 ans ou de moins de 36,3 kg ne peuvent pas utiliser de VFI gonflables. Elles doivent utiliser des VFI flottants qui n’ont pas besoin d’être gonflés.</p>
        <p>Les VIF suivants permettent une flottaison adaptée à vos besoins et sont approuvés par Transports Canada{{'\xa0'}}: </p>
        <div class="row">
          <div class="col-sm bg-red text-center p-4 m-3">
            Gilet de sauvetage de la Croix-Rouge pour adultes
          </div>
          <div class="col-sm bg-red text-center p-4 m-3">
            VFI à collet gonflable
          </div>
          <div class="col-sm bg-red text-center p-4 m-3">
            VFI standard
          </div>
          <div class="col-sm bg-red text-center p-4 m-3">
            Ceinture de flottaison gonflable
          </div>
        </div>
        <p>N'oubliez pas que si vous ramez sans la supervision d'un entraîneur, <strong class="text-red">vous êtes obligé d'avoir un VFI dans votre embarcation</strong>. Il s'agit d'une exigence de Transports Canada.</p>
        <p>Les exceptions concernant les embarcations d'aviron énumérées dans le <em>Règlement sur les petits bâtiments</em> sont aussi détaillées dans le document <em>Ramer en sécurité{{'\xa0'}}: Exigences et directives en matière de sécurité</em>, alors assurez vous de consulter le document publié sur le site web de RCA. </p>
        <button-sequenced
          class="btn-nav--red"
          :loc="41"
          link="sb-41"
        >
          Je consulterai les exigences et les lignes directrices
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-41 -->
    <div
      id="sb-41"
      v-if="$store.state.currentLocation >= 41"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Suivre les règles de circulation nautique  </h2>
        <p>Il n'y a pas que des rameurs sur un plan d'eau. À moins que le plan d'eau ne soit privé, il peut être utilisé par quiconque. Il est aussi fréquent d'y voir des animaux comme des canards et des castors.</p>
        <p>Voici quelques conseils pour éviter les accidents sur l'eau.</p>
        <div class="accordion-group">
          <accordion
            header-text="Avant de sortir sur l'eau"
            class="accordion--red"
          >
            <ul>
              <li>Apprenez les règles de circulation de votre club.</li>
              <li>Familiarisez-vous avec la circulation sur le plan d'eau utilisé.</li>
              <li>Assurez-vous d'avoir vos médicaments d'urgence en cas de besoin, comme votre inhalateur ou votre auto-injecteur d'adrénaline (EpiPen).</li>
              <li>Prévoyez des endroits où vous arrêter et vous reposer en toute sécurité, loin de la circulation.</li>
              <li>Pensez à un lieu de refuge (pas le quai) où vous pouvez sortir de votre embarcation si le temps change subitement ou que vous avez un problème d'équipement ou personnel.</li>
            </ul>
          </accordion>
          <accordion
            header-text="Sur l'eau"
            class="accordion--red"
          >
            <ul>
              <li>Suivez le plan de circulation de votre club.</li>
              <li>Gardez à l’esprit que ceux qui naviguent sur le plan d'eau peuvent ne pas connaitre le plan de circulation de votre club.</li>
              <li>Respectez le droit de passage.</li>
              <li>Faites attention aux obstacles submergés ou visibles et à toute autre activité récréative (la voile, le kayak ou la planche à bras) pratiquée autour de vous.</li>
              <li>Surveillez votre trajectoire et regardez autour de vous souvent.</li>
              <li>Ayez conscience de votre capacité d'entraînement et de vos limites physiques.</li>
            </ul>
          </accordion>
        </div>
        <button-sequenced
          class="btn-nav--red"
          :loc="42"
          link="sb-42"
        >
          Voilà des éléments importants
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-42 -->
    <div
      id="sb-42"
      v-if="$store.state.currentLocation >= 42"
    >
      <content-block class="quiz-bg">
        <h2 class="content-block__header ">Essentiellement</h2>
        <quiz-radio
          :questions="q01"
          @quiz-complete="
                $store.dispatch('showNext', { n: 43, el: '#menu' })
              "
        ></quiz-radio>
      </content-block>
    </div>

    <footer
      class="course-menu"
      id="menu"
      v-if="$store.state.currentLocation >= 43"
    >
      <h3>Menu principal</h3>
      <cac-menu :menuItems="$store.state.menuItems"></cac-menu>
    </footer>
  </section>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import CacHeader from '@/components/cac-components/CacHeader.vue';
import CacMenu from '@/components/cac-components/CacMenu.vue';
import BannerFullWidth from '@/components/BannerFullWidth.vue';
import ContentBlock from '@/components/ContentBlock.vue';
import ButtonSequenced from '@/components/ButtonSequenced.vue';
import AccordionIcon from '@/components/AccordionIcon.vue';
import Accordion from '@/components/Accordion.vue';

// Quiz stuff
import QuizRadio from '@/components/QuizRadio.vue';
import QuizCheckbox from '@/components/QuizCheckbox.vue';

export default {
  name: 'nccp',
  components: {
    CacHeader,
    CacMenu,
    BannerFullWidth,
    ContentBlock,
    ButtonSequenced,
    AccordionIcon,
    Accordion,
    QuizRadio
  },
  data() {
    return {
      showModal: false,
      // 3-01-03
      q01: [
        // Q1
        {
          id: 0,
          questionText: `
            <p class="text-key-take">Parmi ces facteurs, lequel est le plus important en aviron?</p>
          `,
          questionArray: [
            'Votre aptitude à nager',
            'Votre plan de sécurité global',
            'Apporter un VFI en bon état',
            'Vos connaissances du plan d\'eau',
            'Porter les vêtements adéquats'
          ],
          corrective: 'Votre plan de sécurité global',
          model: [],
          answer: '',
          answerText: `
            <p>Votre plan de sécurité global est l'élément le plus important à considérer avant d'aller sur l'eau. Cela comprend votre aptitude à nager, le VFI, le port de vêtements appropriés et les connaissances du plan d'eau. </p>
          `,
        },
      ],
    };
  },
  methods: {
    tabContent(index) {
      this.tabIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
/*------------------------------------*\
    #PRIMARY COLOURS
  \*------------------------------------*/

/*------------------------------------*\
    #Mixins
  \*------------------------------------*/

/*------------------------------------
    #MEDIA SCREENS < 768px (#MOBILE FIRST)
  \*------------------------------------*/
.banner {
  // background-image: url('../assets/img/_chapter-headers/mbl/01-welcome-mbl.png');
  background-image: url("../assets/img/_chapter-headers/mbl/6-individual-safety-mbl-fr.jpg");
  color: #000;
  background-position: center;
  padding: 60% 10%;
  &__header {
    color: #000;
  }
}

/*------------------------------------*\
    #MEDIA SCREENS > 576px (TABLETS)
  \*------------------------------------*/
@media (min-width: 576px) {
  .banner {
    // background-image: url('../assets/img/_chapter-headers/dsk/01-welcome-dsk.png');
    background-image: url("../assets/img/_chapter-headers/dsk/6-individual-safety-dsk-fr.jpg");
    color: #000;
    padding: 10% 10% 14%;
    background-position: center;
    &__header {
      color: #000;
    }
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
  // .banner {
  //   background-image: url('../assets/img/_bg/1-01-01-bg-dsk.png');
  //   color: #fff;
  //   padding: 10% 10%;
  //   background-position: center;
  //   &__header {
  //       color: #fff;
  //   }
  // }
}

/*------------------------------------*\
    #MEDIA SCREENS > 992px
    (LAPTOP, TABLET)
  \*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1200px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1320px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1600px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
